/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface DatasetPolymorphicConciergeDataset
 */
export interface DatasetPolymorphicConciergeDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPolymorphicConciergeDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DatasetPolymorphicConciergeDataset
   */
  readonly id: number;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicConciergeDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {string}
   * @memberof DatasetPolymorphicConciergeDataset
   */
  rawData: string;
}

/**
 * Check if a given object implements the DatasetPolymorphicConciergeDataset interface.
 */
export function instanceOfDatasetPolymorphicConciergeDataset(
  value: object,
): value is DatasetPolymorphicConciergeDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('rawData' in value) || value['rawData'] === undefined) return false;
  return true;
}

export function DatasetPolymorphicConciergeDatasetFromJSON(json: any): DatasetPolymorphicConciergeDataset {
  return DatasetPolymorphicConciergeDatasetFromJSONTyped(json, false);
}

export function DatasetPolymorphicConciergeDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DatasetPolymorphicConciergeDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    hasPredictions: json['has_predictions'],
    rawData: json['raw_data'],
  };
}

export function DatasetPolymorphicConciergeDatasetToJSON(
  value?: Omit<DatasetPolymorphicConciergeDataset, 'id' | 'hasPredictions'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    raw_data: value['rawData'],
  };
}
